import { useShallowSelector } from 'components/WorkspaceEditor/Workspace2Store'
import { useNotification } from 'components/WorkspaceEditor/services'
import { ElementTreeView } from 'components/WorkspaceEditor/types'
import { ElementType } from 'pages/ProjectsPage/WorkspacePage/components/constants'
import { useCallback } from 'react'

const WARNING_DESCRIPTION = {
    Divisions: {
        title: 'Add New Content at the Section Level',
        description: `To add a new article or paragraph, navigate to the Section level. Product Types don't support article creation.`,
    },
    Assemblies: {
        title: 'Add New Content at the Family Level',
        description: `To add a new article or paragraph, navigate to the Family level. Product Types don't support article creation.`,
    },
} as const

/**
 * Hook that manages article creation permissions based on element type.
 * Provides notification functionality when creation is restricted.
 */
export const usePTCreationPermission = () => {
    const notification = useNotification()

    const selectedElementType = useShallowSelector(
        (state) => state.selectedProjectElementNode?.elementType
    )

    const isProductTypeSelected =
        selectedElementType === ElementType.PRODUCTTYPE

    const showRestrictionNotification = useCallback(
        (elementTreeView: ElementTreeView) => {
            const isDivisionsView = elementTreeView === 'Divisions'
            const message = isDivisionsView
                ? WARNING_DESCRIPTION.Divisions.title
                : WARNING_DESCRIPTION.Assemblies.title
            const description = isDivisionsView
                ? WARNING_DESCRIPTION.Divisions.description
                : WARNING_DESCRIPTION.Assemblies.description

            notification.warning({
                message,
                description,
            })
        },
        [notification]
    )

    return {
        isAllowed: !isProductTypeSelected,
        showRestrictionNotification,
    }
}
